exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".img-list>div[data-v-4c118420],.img-list[data-v-4c118420]{display:flex;flex-wrap:wrap}.img-box img[data-v-4c118420]{width:50px;height:50px;margin:2px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=data-v-4c118420&scoped=true!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/views/OperationManage/UserAdminister/PersonalizedPart/PersonalizedPart.vue
// module id = 517
// module chunks = 0